import { Tooltip } from '@material-ui/core';
import { t } from 'i18next';
import { type Id, toast, type ToastOptions } from 'react-toastify';

import api from '../api';

const toastMeta: { id: null | Id } = { id: null };

function getRaytekPaddingRight() {
  return import.meta.env.VITE_APP_CUSTOMER === 'RAYTEK' ? 24 : 0;
}

export function errorToast(
  msg: string,
  shouldDismissAllToast: boolean = true,
  options?: ToastOptions | undefined
) {
  if (shouldDismissAllToast) {
    dismissAllToast();
  }
  toastMeta.id = toast.error(t(msg), {
    ...options,
    style: {
      ...options?.style,
      width: '100%',
      paddingRight: getRaytekPaddingRight(),
    },
  });
}

export function successToast(
  msg: string,
  shouldDismissAllToast: boolean = true,
  options?: ToastOptions | undefined
) {
  if (shouldDismissAllToast) {
    dismissAllToast();
  }
  toastMeta.id = toast.success(t(msg), {
    ...options,
    style: {
      ...options?.style,
      width: '100%',
      paddingRight: getRaytekPaddingRight(),
    },
  });
}

export function infoToast(
  msg: string,
  shouldDismissAllToast: boolean = true,
  options?: ToastOptions | undefined
) {
  if (shouldDismissAllToast) {
    dismissAllToast();
  }
  toastMeta.id = toast(t(msg), {
    ...options,
    style: {
      ...options?.style,
      width: '100%',
      paddingRight: getRaytekPaddingRight(),
    },
  });
}

export function warningToast(
  msg: string,
  shouldDismissAllToast: boolean = true,
  options?: ToastOptions | undefined
) {
  if (shouldDismissAllToast) {
    dismissAllToast();
  }
  toastMeta.id = toast.warning(t(msg), {
    ...options,
    style: {
      ...options?.style,
      width: '100%',
      paddingRight: getRaytekPaddingRight(),
    },
  });
}

const SAVE_TIMEOUT_SECONDS = 7;

export async function waferSaveToast(
  waferId: number,
  onSave: () => void,
  onDiscard: () => void
) {
  dismissAllToast();

  let resolved = false;
  const resolve = (action: 'save' | 'discard') => {
    if (resolved) {
      return;
    }
    resolved = true;
    if (action === 'save') {
      onSave();
    } else {
      onDiscard();
    }
  };

  const waferName: string = await api
    .getWaferImage('', waferId)
    .then(data => data.organization_wafer_id);

  let interval: ReturnType<typeof setInterval> | null = null;

  toastMeta.id = toast(
    ({ closeToast }: { closeToast?: () => void }) => {
      let counter = SAVE_TIMEOUT_SECONDS;
      interval = setInterval(() => {
        counter--;
        if (counter === 0) {
          clearInterval(interval!);
          interval = null;
        }
        const timerSpan = document.getElementById('save-timer-12ssqq12');
        if (timerSpan) {
          timerSpan.innerText = counter.toString();
        }
      }, 1000);

      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            paddingRight: getRaytekPaddingRight(),
            width: '100%',
          }}
        >
          <span style={{ overflowWrap: 'anywhere' }}>
            <strong>
              {t('Saving labels for Wafer')}{' '}
              {waferName.length > 40 ? (
                <Tooltip title={waferName}>
                  <span>{waferName.slice(0, 37) + '...'}</span>
                </Tooltip>
              ) : (
                waferName
              )}
            </strong>
            <br />
            {t('Labels will save in')}{' '}
            <span id='save-timer-12ssqq12'>{SAVE_TIMEOUT_SECONDS}</span>
            {t('s unless you discard.')}
          </span>
          <button
            onClick={() => {
              resolve('discard');
              closeToast?.();
            }}
            style={{
              backgroundColor: '#ff7373ff',
              color: '#fff',
              border: 'none',
              padding: 4,
              borderRadius: 4,
              fontSize: 12,
              cursor: 'pointer',
              width: 'fit-content',
              alignSelf: 'flex-end',
            }}
          >
            {t('Discard')}
          </button>
        </div>
      );
    },
    {
      autoClose: SAVE_TIMEOUT_SECONDS * 1000,
      closeOnClick: false,
      onClose: () => {
        if (interval !== null) {
          clearInterval(interval);
          interval = null;
        }
        resolve('save');
      },
    }
  );
}

function dismissAllToast() {
  if (toastMeta.id) {
    toast.clearWaitingQueue();
    toast.dismiss(toastMeta.id);
  }
}
